/* eslint-disable max-len */
import 'react';

const RetrySvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="1em" height="1em" viewBox="0 0 20 20" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <g
                stroke="#878D99"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.25}
            >
                <path d="M14.31 7.896A5 5 0 005 8.508M14.932 6.189l-.347 1.97-1.97-.348" />
                <g>
                    <path d="M5.69 12.104a5 5 0 009.31-.612M5.068 13.811l.347-1.97 1.97.348" />
                </g>
            </g>
        </g>
    </svg>
);

export default RetrySvg;
